import React, { useState, useEffect } from "react";
import Modal from "react-bootstrap/Modal";
import { useSelector, useDispatch } from "react-redux";
import { pushNotification } from "utils/notifications";
import {
  getListHopDongChoDuyet,
  updateDataSearch,
} from "../../../../../actions/DanhSachHopDongChoDuyet";
import DanhSachHopDongChoDuyetApi from "../../../../../service/danhSachHopDongChoDuyetApi";
import CheckNoXauApi from "../../../../../service/checkNoXauApi";
export const ModalXacNhanDuyet = (props) => {
  const dispatch = useDispatch();
  const listHopDongChoDuyetFull = useSelector(
    (state) => state.listHopDongChoDuyetFull
  );
  const dataSearch = useSelector((state) => state.dataSearchHopDongChoDuyet);
  const [isShowDuyet, setShowDuyet] = useState(true);
  const GuiDuyet = () => {
    setShowDuyet(false);
    setTimeout(function () {
      onSubmit();
    }, 1000);
  };
  useEffect(() => {
    checkNoXau();
  }, []);

  const [IsNoXau, setIsNoXau] = useState(false);
  const checkNoXau = () => {
    CheckNoXauApi.checkNoXau(props.item.Phone, props.item.CMT).then(
      (response) => {
        if (response && response.data && response.data.NoXau != null) {
          setIsNoXau(response.data.NoXau);
        }
      }
    );
  };

  const onSubmit = () => {
    DanhSachHopDongChoDuyetApi.duyetHopDongChoDuyet(props.chovayId).then(
      (response) => {
        if (response.data.Error === 1) {
          pushNotification(response.data.Message, "error", "TOP_CENTER", 1000);
        } else {
          dispatch(getListHopDongChoDuyet(dataSearch));
          props.onHide();
          pushNotification(
            "Duyệt hợp đồng thành công",
            "success",
            "TOP_CENTER",
            1000
          );
        }
        setShowDuyet(true);
      }
    );
  };
  return (
    <Modal
      {...props}
      size="modal-dialog modal-dialog"
      aria-labelledby="contained-modal-title-vcenter"
      centered
      className="modal-new modal fade text-left"
    >
      <Modal.Header>
        <h4 className="modal-title color7-bold" id="myModalLabel16">
          <span className="btn-icon-right">
            <i className="fas fa-user-check"></i>
          </span>
          <span style={{ marginLeft: "-20px", marginTop: "10px" }}>
            Xác nhận duyệt
          </span>
        </h4>
        <button
          type="button"
          className="close-popup-new"
          onClick={props.onHide}
        >
          <i className="mdi mdi-close"></i>
        </button>
      </Modal.Header>
      <Modal.Body className="">
        <form className="form tat-toan form-horizontal">
          <div className="form-body">
            <div className="form-body">
              {IsNoXau == true ? (
                <>
                  <div className="col-md-12">
                    <div className="form-group row">
                      <label
                        className="col-md-12 label-control text-left"
                        for="projectinput2"
                      >
                        <div
                          style={{
                            borderWidth: "1px",
                            borderStyle: "solid",
                            borderColor: "orange",
                            borderRadius: "0.25rem",
                            backgroundColor: "#ffedcb",
                            color: "#d50000",
                            padding: "3px",
                            textAlign: "center",
                          }}
                        >
                          <i className="mdi mdi-information-outline"></i>
                          <span style={{ paddingLeft: "5px" }}>
                            Khách hàng {props.item.CustomerName} đang ở tình
                            trạng nợ xấu
                          </span>
                        </div>
                      </label>
                    </div>
                  </div>
                </>
              ) : (
                <> </>
              )}
              <div className="col-md-12">
                <div className="form-group row">
                  <label
                    className="col-md-12 label-control text-left"
                    for="projectinput2"
                  >
                    <span className="canh-bao">
                      Bạn có chắc chắn duyệt vay cho hợp đồng{" "}
                      <span className="blue">{props.item.Code}</span> của khách
                      hàng{" "}
                      <span className="blue">{props.item.CustomerName}</span>{" "}
                      không ?{" "}
                    </span>
                  </label>
                </div>
              </div>
            </div>
          </div>
        </form>
      </Modal.Body>
      <Modal.Footer>
        {isShowDuyet && (
          <button
            type="button"
            className="btn btn-new-main btn-checknew"
            onClick={GuiDuyet}
          >
            <span className="btn-icon-left">
              <i className="mdi mdi-check"></i>
            </span>
            Xác nhận
          </button>
        )}

        <button
          type="button"
          className="btn btn-new-main btn-closenew"
          onClick={props.onHide}
        >
          <span className="btn-icon-left">
            <i className="mdi mdi-close"></i>
          </span>
          Đóng
        </button>
      </Modal.Footer>
    </Modal>
  );
};
